export const userRole = {
    Admin: 1,
    Archivio_Riviste_User: 2,
    U_C_User: 3
}


export const canAccess = (allowedRoles, role) => {
    role = +role
    return allowedRoles.includes(role)
}


// WEBPACK FOOTER //
// ./src/util/UserRole.js